var React = require('react');
var helpers = require('svg-react-loader/helpers')(require('react-dom'));

module.exports = React.createClass({

    displayName: "Logo1st",

    getDefaultProps () {
        return {"xmlns":"http://www.w3.org/2000/svg","className":"dibsvg-svg dibsvg-logo-1st","viewBox":"0 0 517 323"};
    },

    componentDidMount () {
        helpers.applyXmlAttributes(this);
    },

    render () {
        var props = this.props;
        var children = props.children;

        return (
            <svg {...this.props}>
                  <title>
        1stdibs.com
    </title>
  <path d="M120.4 297.7c-2.8-3.9-4.2-7.7-4.2-11.4s2-12.3 6-26L199.7 0H190L72.4 28.1l2 8.6c11.3-1.2 18.9-1.8 22.8-1.8 7.8 0 13.8 2 18 6 4.2 4 6.3 9.4 6.3 16.2 0 3.5-.5 7.2-1.4 11.2-.3 1.4-4.1 13.8-11.3 37.3L63.2 260.3C58.3 277 53.9 288 50 293.2c-3.9 5.2-8.9 9-15 11.3-6.1 2.3-16.9 3.6-32.5 3.9L0 316.6h156.7l2.5-8.2c-16.5-.9-26.4-2-29.7-3.1-3.2-1.2-6.3-3.7-9.1-7.6z"/>
  <path d="M340.2 112.2c-4.1 0-9.6-.9-16.5-2.6-13.8-3.5-25.4-5.2-34.9-5.2-21.7 0-38.6 5.5-50.6 16.5s-18 24.8-18 41.4c0 9.8 2 18.5 6 26.2 5.7 10.6 17.4 25.5 35.3 44.9 13 14.2 21.3 24.6 24.8 31.3 3.6 6.7 5.4 13.6 5.4 20.8 0 7.3-2.7 13.6-8.2 18.9-5.5 5.3-12.4 7.9-20.8 7.9-7.2 0-14.7-2.3-22.4-7-7.8-4.7-14-11-18.7-18.9-4.7-7.9-9.7-21.2-15-39.7h-7.4l-11.3 76.2h8.6c2.6-3.5 5-5.8 7.1-6.9 2.1-1.1 5.1-1.6 8.9-1.6 4.3 0 10.7 1.2 19.3 3.5 13 3.4 23.9 5.1 32.8 5.1 13.1 0 25.8-3.2 38-9.7 12.2-6.5 21.3-15 27.4-25.7 6.1-10.7 9.2-22.1 9.2-34.1 0-11.1-2.6-21.5-7.8-31.2-5.2-9.7-19.9-27.5-44-53.5-6.9-7.3-11.3-13.1-13.3-17.4-2-4.3-3-8.8-3-13.7 0-5.8 2.3-10.7 6.9-14.9 4.6-4.1 10.4-6.2 17.4-6.2 11.4 0 22.1 5.2 32.1 15.7s15.6 24.8 16.8 42.9h8.6l10.2-70.7h-8.2c-4 5.1-8.8 7.7-14.7 7.7z"/>
  <path d="M482.9 136.8h26l8-26.2h-25.6l19.2-62.1h-12.4c-19.4 21.3-35.9 36.7-49.6 46.3-13.7 9.6-29.9 18-48.5 25.1l-4.3 16.9H425l-39 124.1c-4.3 13.9-6.4 25.3-6.4 34.2 0 8 2.9 14.7 8.6 19.9 5.7 5.2 13.8 7.9 24.2 7.9 12.2 0 24.7-4.3 37.4-12.8 12.7-8.6 24.3-22 34.8-40.4l-8.2-5c-9.3 13.3-17.4 22.6-24.5 28-2.7 2.1-5.4 3.2-8 3.2-1.7 0-3.2-.5-4.6-1.6-1.4-1.1-2.1-2.3-2.1-3.8 0-4.3 1.3-10.7 4-19l41.7-134.7z"/>
                {React.Children.map(children, (c) => (c))}
            </svg>
        );
    }
});



// WEBPACK FOOTER //
// ./src/logo-1st.svg